// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { Link as RouterLink } from 'components/RouterLink';
import { BodySmall } from 'components/Text';
import type { MiniSubsite, Subsite } from 'api/website';
import { colors } from '../theme';

const SubsiteLink = styled(
  ({
    className,
    label,
    url,
    selected,
    parentSubsite
  }: {
    className: string,
    label: string,
    url: string,
    selected: boolean,
    parentSubsite: Subsite
  }) => (
    <Box
      alignItems="center"
      className={className}
      component={RouterLink}
      data-qa-id="side-filter"
      data-qa-selected={selected}
      data-qa-value={url}
      display="flex"
      px={18}
      height={50}
      justifyContent="space-between"
      my="2px"
      color={colors.battleshipGrey}
      bg={colors.platinum}
      textAlign="left"
      textDecoration="none"
      to={{
        pathname: `/${url}`,
        state: {
          parentSubsite
        },
        search: 'pq=&searchMode=true'
      }}
      width={1}
    >
      <BodySmall>{label}</BodySmall>
    </Box>
  )
)`
  &:hover,
  &:focus {
    color: ${colors.waterBlue} !important;
  }
`;
export default ({
  subsites,
  parentSubsite
}: {
  subsites: Array<MiniSubsite>,
  parentSubsite: Subsite
}) => (
  <Box data-qa-id="side-filter-facet-subsites">
    <BodySmall>{getText('Category')}</BodySmall>
    <Box
      data-qa-id="search-filter-section-filters"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      mt={16}
    >
      {subsites.map(subsite => (
        <SubsiteLink
          key={subsite.id}
          parentSubsite={parentSubsite}
          label={subsite.publicName}
          url={subsite.homePage.url}
        />
      ))}
    </Box>
  </Box>
);
